<template>
  <component :is="layoutComponent">
    <router-view />
  </component>
</template>

<script setup>
import { computed } from "vue";
import { useRoute } from "vue-router";

import AuthLayout from "@/layouts/AuthLayout.vue";
import MainLayout from "@/layouts/MainLayout.vue";
// import AdminLayout from "@/layouts/AdminLayout.vue";
// import StaffLayout from "@/layouts/StaffLayout.vue";

const route = useRoute();

const layoutComponent = computed(() => {
  const layout = route.meta.layout;
  if (layout === "default") return MainLayout;
  // if (layout === "superadmin") return SuperadminLayout;
  // if (layout === "staff") return StaffLayout;
  return AuthLayout;
});
</script>

<style>
#app {
  font-family: "Nunito";
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
